<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="loan">
  <header class="loan--header">
    <div class="loan--header__container">
      <h5 class="loan--header__title">
        {{ 'newRequestES' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestType"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
